// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    color: inherit;\n    vertical-align: middle;\n    fill: none;\n    stroke: currentColor;\n}\n.svg-fill {\n    fill: currentColor;\n    stroke: none;\n}\n.svg-up {\n    /* default */\n    transform: rotate(0deg);\n}\n.svg-right {\n    transform: rotate(90deg);\n}\n.svg-down {\n    transform: rotate(180deg);\n}\n.svg-left {\n    transform: rotate(-90deg);\n}", ""]);
// Exports
module.exports = exports;
